import React from "react";
import Site2Layout from "./Site2Layout";

const VISION_ITEMS = [
  {
    tag: "Our Vision",
    icon: "🔭",
    color: "#481F57",
    title: "To be a Trusted Partner",
    text: "To be a trusted partner in developing our clients' businesses — guiding them from opportunity identification all the way through to market leadership.",
    image: "https://res.cloudinary.com/dxity6o7b/image/upload/v1682163425/GuysHilltop_dcbw8h.jpg",
  },
  {
    tag: "Our Mission",
    icon: "🎯",
    color: "#6B3080",
    title: "From Idea to Growth",
    text: "To evolve the client's business right from an idea to its birth and growth — delivering actionable intelligence, strategic planning, and hands-on execution at every stage.",
    image: "https://res.cloudinary.com/dxity6o7b/image/upload/v1682163425/SucessWoman_setbuc.jpg",
  },
];

const INDUSTRIES = [
  "Automotive & Auto-Components",
  "Chemicals & Specialty Materials",
  "Engineering & Capital Goods",
  "FMCG & Consumer Products",
  "Healthcare & Pharmaceuticals",
  "Infrastructure & Real Estate",
  "IT & Technology Services",
  "Textiles & Apparel",
];

const Site2Vision = () => (
  <Site2Layout
    tag="Our Direction"
    title="Vision & Mission"
    subtitle="The principles that guide every strategy, every project, and every partnership."
  >
    {/* Vision / Mission cards */}
    <section style={{ backgroundColor: "#ffffff" }} className="py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-12">
        {VISION_ITEMS.map((v, i) => (
          <div
            key={i}
            style={{ background: "#f9fafb", border: "1px solid rgba(72, 31, 87, 0.12)" }}
            className={`rounded-2xl overflow-hidden flex flex-col ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} text-left shadow-sm`}
          >
            <img
              src={v.image}
              alt={v.tag}
              className="w-full md:w-72 h-56 md:h-auto object-cover flex-shrink-0"
            />
            <div className="p-8 flex flex-col justify-center">
              <span
                style={{ color: v.color, borderColor: `${v.color}55` }}
                className="text-xs font-bold tracking-widest uppercase border rounded-full px-3 py-1 mb-4 inline-block w-fit"
              >
                {v.tag}
              </span>
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">{v.icon}</span>
                <h2 style={{ color: v.color }} className="text-2xl font-extrabold">
                  {v.title}
                </h2>
              </div>
              <div style={{ backgroundColor: v.color, width: "40px", height: "3px" }} className="mb-5 rounded" />
              <p className="text-gray-700 text-base leading-8">{v.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>

    {/* Industries */}
    <section
      style={{ backgroundColor: "#f9fafb", borderTop: "1px solid rgba(72, 31, 87, 0.08)" }}
      className="py-20 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span style={{ color: "#481F57", borderColor: "rgba(72, 31, 87, 0.4)" }} className="text-xs font-bold tracking-widest uppercase border rounded-full px-3 py-1 mb-4 inline-block">
            Industries
          </span>
          <h2 className="text-2xl lg:text-4xl font-extrabold text-[#481F57] mt-3">
            Sector Expertise <span className="text-purple-600">Across Industries</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind, i) => (
            <div
              key={i}
              style={{ background: "#ffffff", border: "1px solid rgba(72, 31, 87, 0.12)" }}
              className="rounded-xl px-5 py-4 flex items-center gap-3 hover:shadow-sm transition-all text-left"
            >
              <span style={{ color: "#481F57" }} className="text-base">◈</span>
              <span className="text-gray-800 text-sm font-semibold">{ind}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  </Site2Layout>
);

export default Site2Vision;
